"use client";

import { withFallback } from "../with-fallback";

export const WithdrawElement = withFallback({
	displayName: "WithdrawElement",
	type: "withdraw-element",
} as const);
